var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-amap',{attrs:{"center":_vm.center2,"zoom":_vm.zoom,"events":_vm.events}},[(_vm.value)?_c('el-amap-marker',{attrs:{"position":_vm.value}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }